import { useEffect, useState } from 'react';

const useOrientation = () => {
  const [orientation, setOrientation] = useState(() =>
    window.matchMedia("(orientation: portrait)").matches ? 'portrait' : 'landscape'
  );
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  useEffect(() => {

    const handleOrientationChange = (event) => {
      setOrientation(event.matches ? 'portrait' : 'landscape');
    };

    const mediaQuery = window.matchMedia("(orientation: portrait)");
    mediaQuery.addEventListener('change', handleOrientationChange);

    return () => {
      mediaQuery.removeEventListener('change', handleOrientationChange);
    };
  }, []);

  return isMobile ? orientation : 'portrait';
};

export default useOrientation;